// Resolves the same way schedule targets do: Location > LocationGroup (highest group Priority) > Brand >
// built-in default. A playlist's own slideshowIntervalSeconds overrides whatever this resolves to.
export const PlaylistConfigurationScope = {
    Brand: 0,
    LocationGroup: 1,
    Location: 2,
} as const;

export type PlaylistConfigurationScope = (typeof PlaylistConfigurationScope)[keyof typeof PlaylistConfigurationScope];

export const DEFAULT_SLIDESHOW_INTERVAL_SECONDS = 10;

export interface PlaylistConfiguration {
    id: string;
    brandId: string;
    scopeType: PlaylistConfigurationScope;
    scopeId: string;
    // Seconds each IMAGE item shows before advancing. Videos ignore it and play to their end.
    slideshowIntervalSeconds: number;
    created: string;
    createdBy: string;
    updated?: string | null;
    updatedBy?: string | null;
}

export interface SavePlaylistConfiguration {
    brandId: string;
    scopeType: PlaylistConfigurationScope;
    scopeId: string;
    slideshowIntervalSeconds: number;
}

// scopeType/scopeId are null when nothing is configured anywhere and the built-in default applied — shown
// differently from an explicit brand-level setting that happens to be 10.
export interface EffectivePlaylistConfiguration {
    slideshowIntervalSeconds: number;
    scopeType?: PlaylistConfigurationScope | null;
    scopeId?: string | null;
}

// Day parts moved to @/models/account-management/DayPart — they are an AccountManagement concept meant for
// cross-product reuse, not something playlists own.
